module.exports = __webpack_public_path__ + "img/755.6e8e3f71.png";